<template>
  <div>
    <loading :active="isLoading" :can-cancel="true" color="#173EA3" :is-full-page=fullPage></loading>
    <div style="text-align: right">
      <Button
        icon="pi pi-print"
        @click="printQr()"
        class="p-button-rounded p-button-info mr-2 mb-2"
      />
    </div>
    <div id="printMe">
      <div
        v-for="(result, key) in Printdata"
        :key="key"
      >
      <table :id="'DCprint_' + result.data.sr_no"
  style="
    border: 1px solid black;
    border-collapse: collapse;
    width: 753px;height:1083px;
    margin-left: 30px;
    font-size: 0.875rem;
    margin-top: 20px;margin-bottom:20px;
    font-family: Arial, Helvetica, sans-serif;
  "
>
  <tr>
    
    <td
      colspan="6"
      style="
        text-align: center;
        border: 1px solid black;
        border-collapse: collapse;
        padding-bottom: 0 ;
        font-size: large;
        font-weight: 900 ;
      "
    >
    INSTALLATION REPORT
    </td>
  </tr>
  <tr>
    <td
      colspan="6"
      style="
        text-align: left;
        border: 1px solid black;
        border-collapse: collapse;
      "
    >
      &nbsp;
    </td>
  </tr>
  <tr>
    <td
      colspan="2"
      style="
        text-align: left;
        border: 1px solid black;
        border-collapse: collapse;
		padding-left: 10px;
      "
    >
      <b>Sarvasya Merchandisers Private Limited</b><br>
        16-C,2nd Flr,16,The International Building,<br>
        1st X Road, New Marine Lines, Churchgate,<br>
        Mumbai - 400020
    </td>
    <td
      colspan="4"
      style="
        text-align: center; vertical-align: top;
        border: 1px solid black;
        border-collapse: collapse;padding-left: 30px;
      "
    >
    
    <img src="images/sarvasya-logo-new.png" alt="logo" style="width:150px;height:60px;">
      <!-- <b style="margin-right:15px">Challan No:</b><br>
      <b>Challan Date:</b>  -->
    </td>
  </tr>
  <tr>
    <td
        colspan="2"
        style="
        text-align: left;
        border: 1px solid black;
        border-collapse: collapse;
        padding-left: 10px;width:45%;
        "
    >
    <!-- result.data['visited_date'] -->
      <b>IR No </b> : SMPL/PACS/IR/{{
                result.data["sr_no"]
              }}/23-24  
              
              <b> IR Date :  {{getCurrentDate()}}</b> <br>
              <b> Challan No </b>: SMPL/PACS/{{
                result.data["sr_no"]
              }}/23-24
    </td>
    <td
      colspan="4"
      style="
        text-align: left; vertical-align: top;
        border: 1px solid black;
        border-collapse: collapse;padding-left: 10px;
      "
    >
      <b>P.O No : </b>Agri Credit-12/PAC Comp/Hardware/Sarvasya/2023/1767 <br>
      <b>P.O Date :</b> 21/11/2023
    </td>
  </tr>
 
  <tr>
    <td 
      colspan="2" valign="top"
      style="
        text-align: left;
        border: 1px solid black;
        border-collapse: collapse;
        padding-left: 10px;width:40%;"
        >
        <b>Consignee (Ship To)</b> <br> {{split_name(result.data.group_stops.stop_name)}} <br>
               At-post {{result.data.group_stops.village_name}} , taluka-{{result.data.block_name}} , District-{{result.data.district_name}}
     </td>
    <td colspan="4"
        style="
          text-align: left;
          border: 1px solid black;
          border-collapse: collapse;
          padding-left: 10px;
          ">
          <b>Unique PACS ID </b>{{ result.data.group_stops.PACS_id }}<br> 
           <b> Secretory Name </b>{{ result.data.group_stops.secretory_name }}<br>
           <b> Mobile No. </b>{{ result.data.group_stops.mobile_no }}
          
          <br>
          
        
    </td>
  </tr>

 


  <tr style="background-color: rgb(247, 183, 66);">
    <td   colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      SR No.
    </td>

    <td colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
          width:40%;
      ">
      <b>Description & Specification Of Goods</b>
    </td>

    <td colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
          width:10%;
      ">
      Quantity
    </td>

    <!-- <td colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      Total Qty. of Goods (Nett)
    </td> -->

    <td colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      Serial Number
    </td>

   
  </tr>

  <tr>
    <td   colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      1
    </td>

    <td colspan="1"
        style="
          text-align: left;
          border: 1px solid black;
          border-collapse: collapse;
          width:40%;
          padding-left: 10px;
      ">
      <!-- <b>Desktop(Monitor,CPU,Wired Keyboad & Mouse)s</b><br>
        Dell - Model : Vostro 3710 <br>
        HP - Model : Pro 285 G8 MT -->
       <b>Desktop</b>  <br> Dell Vostro 3710 / HP Pro 285 G8 MT
    </td>

    

    <td colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
          width:10%;
      ">
      1
    </td>

    <td colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      
    </td>

  
  </tr>

  <tr>
    <td   colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      2
    </td>

    <td colspan="1"
        style="
          text-align: left;
          border: 1px solid black;
          border-collapse: collapse;
          width:40%;
          padding-left: 10px;
      ">
      <!-- <b>Desktop(Monitor,CPU,Wired Keyboad & Mouse)s</b><br>
        Dell - Model : Vostro 3710 <br>
        HP - Model : Pro 285 G8 MT -->
        Monitor Dell  19.5" / HP 19.5"
    </td>

    

    <td colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
          width:10%;
      ">
      1
    </td>

    <td colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      
    </td>

  
  </tr>

  
  <tr>
    <td  colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      3
    </td>

    <td colspan="1"
        style="
          text-align: left;
          border: 1px solid black;
          border-collapse: collapse;
          width:40%;
          padding-left: 10px;
      ">
      Webcam<br>
      Model : TVSE W103
    </td>

    <td colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
          width:10%;
      ">
      1
    </td>

    <td colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      
    </td>

   
  </tr>


  <tr>
    <td colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      4
    </td>

    <td colspan="1"
        style="
          text-align: left;
          border: 1px solid black;
          border-collapse: collapse;
          width:40%;
          padding-left: 10px;
      ">
        Multifunction Device MFD (Printer)<br>
        Model: Epson & M2170
    </td>

    <td colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
          width:10%;
      ">
      1
    </td>

    <td colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      
    </td>

   
  </tr>  


  <tr>
    <td   colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      5
    </td>

    <td colspan="1"
        style="
          text-align: left;
          border: 1px solid black;
          border-collapse: collapse;
          width:40%;
          padding-left: 10px;
      ">
        Physical VPN Device<br>
        Model : D Link DIR 825 <br>
        Systrome IG-114C
    </td>

    <td colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
          width:10%;
      ">
      1
    </td>

    <td colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      
    </td>

   
  </tr> 
  
  
  <tr>
    <td   colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      6
    </td>

    <td colspan="1"
        style="
          text-align: left;
          border: 1px solid black;
          border-collapse: collapse;
          width:40%;
          padding-left: 10px;
      ">
        Biometric Scanner <br>
        Model : Mantra and MFS110
    </td>

    <td colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
          width:10%;
      ">
      1
    </td>

    <td colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      
    </td>

   
  </tr> 

  
  <tr>
    <td   colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      7
    </td>

    <td colspan="1"
        style="
          text-align: left;
          border: 1px solid black;
          border-collapse: collapse;
          width:40%;
          padding-left: 10px;
      ">
      <b>Power Backup</b> <br>
        UPS Model : Microtk Luxe 1400 <br>
        
    </td>

    <td colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
          width:10%;
      ">1
      
    </td>

    <td colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      <!-- -<br>1<br>1 -->
    </td>

    
  </tr> 

   
  
  <tr>
    <td   colspan="1" valign="top"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      8
    </td>

    <td colspan="1"
        style="
          text-align: left;
          border: 1px solid black;
          border-collapse: collapse;
          width:40%;
          padding-left: 10px;
      ">
      <!-- Extension Board & Socket -->
     Tubular Jumbo Batteries - 150 AH Battery
    </td>

    <td colspan="1"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
          width:10%;
      ">
      1
    </td>

    <td colspan="1"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      
    </td>

  </tr>

  <tr>
    <td   colspan="1"
        style="
          text-align: left;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      
    </td>

    <td colspan="1"
        style="
          text-align: right;
          border: 1px solid black;
          border-collapse: collapse;
          width:40%;
        ">
        TOTAL
    </td>

    <td colspan="1"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
          width:10%;
      ">
      8
    </td>

    <td colspan="1"
        style="
          text-align: center;
          border: 1px solid black;
          border-collapse: collapse;
      ">
      
    </td>
    </tr>

   
  

  <!-- <tr>
    <td colspan="1"
    style="
      text-align: left;
      border-bottom: 1px solid black;
      border-collapse: collapse; height: 20px;"></td>

    <td colspan="1"
    style="
      text-align: left;
      border-right: 1px solid black;
      border-bottom: 1px solid black;
      border-collapse: collapse; height: 20px;"></td>

    <td colspan="1"
    style="
      text-align: left;
      border-bottom: 1px solid black;
      border-collapse: collapse; height: 20px;"></td>

    <td colspan="1"
    style="
      text-align: left;
      border-right: 1px solid black;
      border-bottom: 1px solid black;
      border-collapse: collapse; height: 20px;"></td>

   
  </tr> -->

  <!-- <tr>
    <td colspan="6"
      style="
        text-align: left;
        padding-left: 10px;
        border-bottom: 1px solid black;
        border-collapse: collapse; 
        height: 20px;">
        Received above mentioned materials in good condition.
    </td>
  </tr> -->

  <tr>
   <td colspan="6" 
    style="
  text-align: left;
  padding-left: 10px;
  border: 1px solid black;
  height: 60px; ">
  <p>a. Battery of Inverter/ UPS:Ensure if is in a cool and dry location with plenty of ventilation and no exposure to moisture or sunlight <br>
  b. Battery of Inverter/ UPS: Use only distilled water for your Inverter battery.<br>
  c. Battery of Inverter/ UPS: Check the level of distilled water in your battery every month<br>
  d. Battery of Inverter/ UPS: wear gloves while filling distilled water in the battery <br>
  e. Battery of Inverter/ UPS: Set a smartphone reminder at regular intervals that provide you notification about water levels.<br>
  f. Battery of Inverter/ UPS: Top up distilled water in the battery every 6 months.<br>
  g. Web Camera & Biometric Device: USB Cable wear and tears,physical damages due to rats or similar damages will bot be covered under warranty. 
     Hence proper care to be taken while usage of the same material.<br>
  h. Printer. Genuine ink bottles of OEM company should be used for printer. Duplicate ink bottle/toner refilling will void the warranty.<br>
  i. Earthing is MUST for all locations. warranty gets void if Consignee location earthing is not done or if any fault is found in earthing.<br>
  j. Since all material supplied will be Electronic material, the place where the material is to be installed should be safe fro rain water and other
    possible damage conditions if any like rats,dust etc.
 </p> 
</td>
</tr>
<!-- <tr>
  <td colspan="6" valign="top"
  style="
    text-align: left;
    padding-left: 10px;
    border-left: 1px solid black;
    border-collapse: collapse; 
    height: 20px; ">
    <b>Sarvasya Merchandisers Private Limited</b>
    <p style="margin-top: 300px;"> <b>AUTHORISED SIGNATORY</b></p>
</td>
</tr> -->

<tr>
  <td colspan="3" valign="bottom"
    style="
      text-align: left;
      padding-left: 20px;
      border-collapse: collapse; 
      height: 20px;">
      <!-- <b>Received and installed the above mentioned material in working good condition</b> -->
      <b>Recieved and installed the above mentioned materials and working in good condition</b>
      <br>
      <br>
      <br>
      <br><b>sign:</b>
      <br><br> <b>Name:</b><br><br> <b>Mobile:</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>Date:</b> 
    </td>

  <td colspan="3" valign="top"
    style="
      text-align: left;
      padding-left: 20px;
      border-left: 1px solid black;
      border-collapse: collapse; 
      height: 60px; ">
      <b>Sarvasya Merchandisers Private Limited</b>
      <p style="margin-top: 120px;"> <b>AUTHORISED SIGNATORY</b></p>
  </td>
</tr>
<tr>
    
  
</tr>
  
  
  
 
</table>



        
      </div>
    </div>
  </div>
</template>
<script>
import ProductService from "../../service/ProductService";
import { FilterMatchMode } from "primevue/api";
import apis from "@/apis";
import { jsPDF } from "jspdf";

import QrcodeVue from "qrcode.vue";
export default {
  props: ["Printdata"],
  data() {
    return {
      isLoading: false,
      fullPage: true,
    };
  },
  methods: {
    split_name(data)
    {
      var info=data.split("-");
      if (info.length>1) 
      {
        info.pop();
      }
      return info.toString();
    },
    async print_Qr() 
    {
      const pdf = new jsPDF();

            for (let i = 0; i < this.Printdata.length; i++) 
            {
              console.log('DCprint_' + this.Printdata[i].data.sr_no);
              const canvas = document.getElementById('DCprint_' + this.Printdata[i].data.sr_no);

              
              pdf.html(canvas);
              if (i < this.Printdata.length - 1) 
              {
                pdf.addPage();
              }
            }
          pdf.save("DC.pdf");

    },
    printQr() {
      this.isLoading=true;
      const pdfWidth = 800;
      const pdfHeight = 1103.55;
      const pdfContent = document.getElementById("printMe");
      const pdf = new jsPDF({
        unit: "mm",
        format: [pdfWidth, pdfHeight], // A4 size by default, you can customize this
        orientation: "portrait", // 'portrait' or 'landscape'
        autoPaging: 'text'
      });
      //const pdf = new jsPDF('portrait', 'pt', 'a4');
      
      pdf.html(pdfContent, {
        callback: (pdf)=> {
          // Save or display the generated PDF
          pdf.save("Installation_Report.pdf");
          this.isLoading=false;
          this.$emit("submit");          
        },
      });
      
    },
    getCurrentDate()
  {
    var fullDate = new Date();
    var twoDigitMonth = fullDate.getMonth() + 1;
    return  fullDate.getDate() + "/" + twoDigitMonth + "/" + fullDate.getFullYear();
  },
  getCurrentDateDMY(data)
  {
    if (data=='') 
    {
      return ;
    }
    var fullDate = new Date(data);
    var twoDigitMonth = fullDate.getMonth() + 1;
    return  fullDate.getDate() + "/" + twoDigitMonth + "/" + fullDate.getFullYear();
  }
  },
  
  mounted() {
    console.log(this.Printdata);
  },
  components: { QrcodeVue },
};
</script>
<style>
.page-break {
  page-break-after: always !important;
}
</style>